// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__ql8wB","select":"Header_select__1bFo2","clinic":"Header_clinic__3JBit"};